<template>
  <v-footer class="footer-section" padless>
    <v-container fluid class="py-10">
      <v-row align="center" justify="center">
        <v-col cols="10" lg="8">
          <v-row align="center" justify="space-between">
            <!-- Marca -->
            <v-col
              cols="12"
              sm="auto"
              class="text-center text-sm-left mb-6 mb-sm-0"
            >
              <div class="footer-brand-wrap">
                <!-- Disco claro: garante que as duas cores da marca apareçam
                     sobre o fundo pinheiro, sem filtro CSS. -->
                <span class="footer-mark">
                  <img src="@/assets/salvia_symbol.svg" alt="" aria-hidden="true" />
                </span>
                <div class="text-left">
                  <span class="footer-brand">Salvia</span>
                  <span class="footer-tagline">
                    Gestão de tratamentos de saúde
                  </span>
                </div>
              </div>
            </v-col>

            <!-- Redes -->
            <v-col cols="12" sm="auto" class="text-center mb-6 mb-sm-0">
              <v-btn
                v-for="(icon, i) in icons"
                :key="i"
                icon
                small
                :href="icon.link"
                target="_blank"
                rel="noopener"
                :aria-label="icon.label"
                class="footer-social-btn mx-1"
              >
                <v-icon size="18">{{ icon.text }}</v-icon>
              </v-btn>
            </v-col>

            <v-col cols="12" sm="auto" class="text-center text-sm-right">
              <span class="footer-copy">
                &copy; {{ new Date().getFullYear() }} Salvia. Todos os direitos
                reservados.
              </span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    icons: [
      { text: "mdi-facebook", link: "", label: "Facebook" },
      { text: "mdi-instagram", link: "", label: "Instagram" },
      { text: "mdi-linkedin", link: "", label: "LinkedIn" },
    ],
  }),
};
</script>

<style scoped>
.footer-section {
  background-color: #1f4d3f !important; /* pinheiro profundo (nunca #000) */
  border-top: 3px solid #e8a04b; /* fio de areia: acento da marca */
}

.footer-brand-wrap {
  display: inline-flex;
  align-items: center;
  gap: 12px;
}

.footer-mark {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: var(--ds-surface);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.footer-mark img {
  width: 26px;
  height: 26px;
  display: block;
}

.footer-brand {
  display: block;
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--ds-surface);
  letter-spacing: 0.4px;
  line-height: 1.2;
}

.footer-tagline {
  display: block;
  font-size: 0.75rem;
  color: rgba(239, 233, 221, 0.6);
  letter-spacing: 0.2px;
}

.footer-social-btn {
  color: rgba(239, 233, 221, 0.55) !important;
  transition: color 0.2s ease, transform 0.2s ease;
}
.footer-social-btn:hover {
  color: #e8a04b !important;
  transform: translateY(-2px);
}

.footer-copy {
  font-size: 0.8rem;
  color: rgba(239, 233, 221, 0.5);
}
</style>
